import Navbar from '../../components/feature/Navbar';
import Footer from '../../components/feature/Footer';
import { Link } from 'react-router-dom';

export default function ServicesPage() {
  return (
    <div className="min-h-screen">
      <Navbar />

      {/* Hero Section */}
      <section className="relative h-[60vh] flex items-center justify-center overflow-hidden">
        <div className="absolute inset-0">
          <img
            src="https://public.readdy.ai/ai/img_res/160bd4d81d9631782f13e209174e4aff.jpg"
            alt="Our Services"
            className="w-full h-full object-cover object-top"
          />
          <div className="absolute inset-0 bg-gradient-to-b from-black/50 via-black/40 to-black/50"></div>
        </div>

        <div className="relative z-10 max-w-4xl mx-auto px-6 text-center">
          <h1 className="text-7xl font-black text-white mb-6 leading-tight">
            Our Services
          </h1>
          <p className="text-xl text-white/90 leading-relaxed">
            Comprehensive demolition solutions for every project type
          </p>
        </div>
      </section>

      {/* Residential Demolition */}
      <section className="py-24 bg-white">
        <div className="max-w-7xl mx-auto px-6">
          <div className="grid grid-cols-1 md:grid-cols-2 gap-16 items-center">
            <div>
              <span className="inline-block px-4 py-2 bg-teal-100 text-teal-700 rounded-full text-xs font-semibold mb-6">
                RESIDENTIAL
              </span>
              <h2 className="text-5xl font-black text-gray-900 mb-6 leading-tight">
                Residential Demolition Services
              </h2>
              <p className="text-gray-600 text-base leading-relaxed mb-6">
                Our residential demolition services cover everything from single-family homes to multi-unit properties. We handle complete house demolitions, partial demolitions, garage removals, and shed teardowns with precision and care.
              </p>
              <ul className="space-y-4 mb-8">
                <li className="flex items-start gap-3">
                  <i className="ri-checkbox-circle-fill text-teal-600 text-xl mt-1"></i>
                  <div>
                    <strong className="text-gray-900 text-sm">Complete Home Demolition</strong>
                    <p className="text-gray-600 text-sm">Full structure removal including foundation</p>
                  </div>
                </li>
                <li className="flex items-start gap-3">
                  <i className="ri-checkbox-circle-fill text-teal-600 text-xl mt-1"></i>
                  <div>
                    <strong className="text-gray-900 text-sm">Partial Demolition</strong>
                    <p className="text-gray-600 text-sm">Selective removal of specific areas or rooms</p>
                  </div>
                </li>
                <li className="flex items-start gap-3">
                  <i className="ri-checkbox-circle-fill text-teal-600 text-xl mt-1"></i>
                  <div>
                    <strong className="text-gray-900 text-sm">Garage & Shed Removal</strong>
                    <p className="text-gray-600 text-sm">Quick and efficient outbuilding demolition</p>
                  </div>
                </li>
                <li className="flex items-start gap-3">
                  <i className="ri-checkbox-circle-fill text-teal-600 text-xl mt-1"></i>
                  <div>
                    <strong className="text-gray-900 text-sm">Debris Removal & Disposal</strong>
                    <p className="text-gray-600 text-sm">Complete cleanup and proper waste management</p>
                  </div>
                </li>
              </ul>
              <Link
                to="/quotations"
                className="inline-block px-8 py-4 bg-teal-600 text-white text-sm font-semibold rounded-lg hover:bg-teal-700 transition-all cursor-pointer whitespace-nowrap"
              >
                Get a Quote
              </Link>
            </div>

            <div className="relative">
              <img
                src="https://readdy.ai/api/search-image?query=residential%20house%20demolition%20excavator%20removing%20suburban%20home%20controlled%20demolition%20process%20family%20home%20being%20torn%20down%20safely%20professional%20residential%20demolition%20work%20organized%20site%20bright%20daylight&width=700&height=700&seq=residential1&orientation=squarish"
                alt="Residential demolition"
                className="w-full h-[700px] object-cover object-top rounded-2xl shadow-xl"
              />
            </div>
          </div>
        </div>
      </section>

      {/* Commercial Demolition */}
      <section className="py-24 bg-gray-50">
        <div className="max-w-7xl mx-auto px-6">
          <div className="grid grid-cols-1 md:grid-cols-2 gap-16 items-center">
            <div className="relative order-2 md:order-1">
              <img
                src="https://readdy.ai/api/search-image?query=commercial%20building%20demolition%20large%20office%20building%20being%20demolished%20heavy%20machinery%20cranes%20and%20excavators%20urban%20demolition%20site%20professional%20industrial%20work%20organized%20construction%20zone%20safety%20protocols&width=700&height=700&seq=commercial1&orientation=squarish"
                alt="Commercial demolition"
                className="w-full h-[700px] object-cover object-top rounded-2xl shadow-xl"
              />
            </div>

            <div className="order-1 md:order-2">
              <span className="inline-block px-4 py-2 bg-amber-100 text-amber-700 rounded-full text-xs font-semibold mb-6">
                COMMERCIAL
              </span>
              <h2 className="text-5xl font-black text-gray-900 mb-6 leading-tight">
                Commercial Demolition Services
              </h2>
              <p className="text-gray-600 text-base leading-relaxed mb-6">
                We specialize in commercial demolition projects of all sizes, from small retail spaces to large industrial complexes. Our experienced contractors handle every aspect of commercial demolition with minimal disruption to surrounding businesses.
              </p>
              <ul className="space-y-4 mb-8">
                <li className="flex items-start gap-3">
                  <i className="ri-checkbox-circle-fill text-amber-600 text-xl mt-1"></i>
                  <div>
                    <strong className="text-gray-900 text-sm">Office Buildings</strong>
                    <p className="text-gray-600 text-sm">Multi-story commercial structure demolition</p>
                  </div>
                </li>
                <li className="flex items-start gap-3">
                  <i className="ri-checkbox-circle-fill text-amber-600 text-xl mt-1"></i>
                  <div>
                    <strong className="text-gray-900 text-sm">Retail Spaces</strong>
                    <p className="text-gray-600 text-sm">Strip malls, shopping centers, and storefronts</p>
                  </div>
                </li>
                <li className="flex items-start gap-3">
                  <i className="ri-checkbox-circle-fill text-amber-600 text-xl mt-1"></i>
                  <div>
                    <strong className="text-gray-900 text-sm">Industrial Facilities</strong>
                    <p className="text-gray-600 text-sm">Warehouses, factories, and manufacturing plants</p>
                  </div>
                </li>
                <li className="flex items-start gap-3">
                  <i className="ri-checkbox-circle-fill text-amber-600 text-xl mt-1"></i>
                  <div>
                    <strong className="text-gray-900 text-sm">Interior Demolition</strong>
                    <p className="text-gray-600 text-sm">Selective interior removal for renovations</p>
                  </div>
                </li>
              </ul>
              <Link
                to="/quotations"
                className="inline-block px-8 py-4 bg-amber-600 text-white text-sm font-semibold rounded-lg hover:bg-amber-700 transition-all cursor-pointer whitespace-nowrap"
              >
                Get a Quote
              </Link>
            </div>
          </div>
        </div>
      </section>

      {/* Specialized Services */}
      <section className="py-24 bg-white">
        <div className="max-w-7xl mx-auto px-6">
          <div className="text-center mb-16">
            <span className="inline-block px-4 py-2 bg-gray-100 text-gray-700 rounded-full text-xs font-semibold mb-6">
              SPECIALIZED
            </span>
            <h2 className="text-5xl font-black text-gray-900 mb-6 leading-tight">
              Specialized Demolition Services
            </h2>
            <p className="text-gray-600 text-base max-w-3xl mx-auto leading-relaxed">
              Beyond standard demolition, we offer specialized services that require advanced equipment, expertise, and safety protocols.
            </p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
            <div className="bg-gray-50 rounded-2xl p-8 hover:shadow-xl transition-shadow">
              <div className="w-16 h-16 bg-teal-100 rounded-full flex items-center justify-center mb-6">
                <i className="ri-hammer-line text-3xl text-teal-600"></i>
              </div>
              <h3 className="text-2xl font-bold text-gray-900 mb-4">
                Concrete Removal
              </h3>
              <p className="text-gray-600 text-sm leading-relaxed mb-4">
                Professional concrete demolition including driveways, foundations, slabs, and structural concrete elements.
              </p>
              <ul className="space-y-2 text-sm text-gray-600">
                <li className="flex items-center gap-2">
                  <i className="ri-arrow-right-s-line text-teal-600"></i>
                  Foundation removal
                </li>
                <li className="flex items-center gap-2">
                  <i className="ri-arrow-right-s-line text-teal-600"></i>
                  Driveway demolition
                </li>
                <li className="flex items-center gap-2">
                  <i className="ri-arrow-right-s-line text-teal-600"></i>
                  Concrete slab removal
                </li>
              </ul>
            </div>

            <div className="bg-gray-50 rounded-2xl p-8 hover:shadow-xl transition-shadow">
              <div className="w-16 h-16 bg-amber-100 rounded-full flex items-center justify-center mb-6">
                <i className="ri-recycle-line text-3xl text-amber-600"></i>
              </div>
              <h3 className="text-2xl font-bold text-gray-900 mb-4">
                Asbestos Abatement
              </h3>
              <p className="text-gray-600 text-sm leading-relaxed mb-4">
                Safe removal and disposal of asbestos-containing materials by certified professionals following all regulations.
              </p>
              <ul className="space-y-2 text-sm text-gray-600">
                <li className="flex items-center gap-2">
                  <i className="ri-arrow-right-s-line text-amber-600"></i>
                  Certified removal
                </li>
                <li className="flex items-center gap-2">
                  <i className="ri-arrow-right-s-line text-amber-600"></i>
                  Safe containment
                </li>
                <li className="flex items-center gap-2">
                  <i className="ri-arrow-right-s-line text-amber-600"></i>
                  Proper disposal
                </li>
              </ul>
            </div>

            <div className="bg-gray-50 rounded-2xl p-8 hover:shadow-xl transition-shadow">
              <div className="w-16 h-16 bg-gray-200 rounded-full flex items-center justify-center mb-6">
                <i className="ri-building-line text-3xl text-gray-700"></i>
              </div>
              <h3 className="text-2xl font-bold text-gray-900 mb-4">
                Selective Demolition
              </h3>
              <p className="text-gray-600 text-sm leading-relaxed mb-4">
                Precision demolition that preserves specific areas while removing others, ideal for renovation projects.
              </p>
              <ul className="space-y-2 text-sm text-gray-600">
                <li className="flex items-center gap-2">
                  <i className="ri-arrow-right-s-line text-gray-700"></i>
                  Interior gutting
                </li>
                <li className="flex items-center gap-2">
                  <i className="ri-arrow-right-s-line text-gray-700"></i>
                  Partial removal
                </li>
                <li className="flex items-center gap-2">
                  <i className="ri-arrow-right-s-line text-gray-700"></i>
                  Structural preservation
                </li>
              </ul>
            </div>
          </div>
        </div>
      </section>

      {/* Process Section */}
      <section className="py-24 bg-gray-900 text-white">
        <div className="max-w-7xl mx-auto px-6">
          <h2 className="text-5xl font-black mb-16 text-center leading-tight">
            Our Demolition Process
          </h2>

          <div className="grid grid-cols-1 md:grid-cols-4 gap-8">
            <div className="text-center">
              <div className="w-20 h-20 bg-teal-600 rounded-full flex items-center justify-center mx-auto mb-6">
                <span className="text-3xl font-black">1</span>
              </div>
              <h3 className="text-xl font-bold mb-3">Site Assessment</h3>
              <p className="text-white/80 text-sm leading-relaxed">
                Thorough evaluation of the property and demolition requirements
              </p>
            </div>

            <div className="text-center">
              <div className="w-20 h-20 bg-teal-600 rounded-full flex items-center justify-center mx-auto mb-6">
                <span className="text-3xl font-black">2</span>
              </div>
              <h3 className="text-xl font-bold mb-3">Permits & Planning</h3>
              <p className="text-white/80 text-sm leading-relaxed">
                Obtaining necessary permits and creating detailed demolition plan
              </p>
            </div>

            <div className="text-center">
              <div className="w-20 h-20 bg-teal-600 rounded-full flex items-center justify-center mx-auto mb-6">
                <span className="text-3xl font-black">3</span>
              </div>
              <h3 className="text-xl font-bold mb-3">Safe Demolition</h3>
              <p className="text-white/80 text-sm leading-relaxed">
                Executing demolition with proper safety protocols and equipment
              </p>
            </div>

            <div className="text-center">
              <div className="w-20 h-20 bg-teal-600 rounded-full flex items-center justify-center mx-auto mb-6">
                <span className="text-3xl font-black">4</span>
              </div>
              <h3 className="text-xl font-bold mb-3">Cleanup & Disposal</h3>
              <p className="text-white/80 text-sm leading-relaxed">
                Complete site cleanup and responsible debris disposal
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* CTA Section */}
      <section className="py-24 bg-teal-600">
        <div className="max-w-4xl mx-auto px-6 text-center">
          <h2 className="text-5xl font-black text-white mb-6 leading-tight">
            Ready to Start Your Project?
          </h2>
          <p className="text-xl text-white/90 mb-10 leading-relaxed">
            Get competitive quotes from licensed demolition professionals in your area
          </p>
          <Link
            to="/quotations"
            className="inline-flex items-center gap-3 px-10 py-5 bg-white text-teal-600 text-base font-bold rounded-full hover:bg-gray-100 transition-all shadow-xl cursor-pointer whitespace-nowrap"
          >
            Request Your Free Quote
            <i className="ri-arrow-right-line text-xl"></i>
          </Link>
        </div>
      </section>

      <Footer />
    </div>
  );
}